import { getBrandData } from "../apiCaching/POST-Requests/helperModules/handleBookingSubmit";
import { isValidCAPostalCode } from "./helper_functions";

/**
 * Handles redirect logic for Neighborly and Corporate brands based on concept ID.
 * Provides static utility methods for zipcode-based redirects with security validations.
 */

export class FindUsComponentRedirect {

    /**
     * Constructs and executes redirect URL with encoded zipcode parameter.
     * @param zipcode - The zipcode to include in redirect
    */
    public static async redirectIfNeeded(zipcode: string, isMultiDomain?: boolean): Promise<void> {
        try {
            let redirectionLink = await this.getRedirectionLinkFromBrandData();
            if (!redirectionLink) {
                console.warn('[FindUsComponentRedirect] No redirection link available');
                return;
            }

            const encodedZipcode = encodeURIComponent(zipcode.trim());
            const urlParts = window.location.href.toLowerCase().split('/');
            const countryCode = urlParts[3] === "ca" ? "ca" : "us";
            if (isValidCAPostalCode(zipcode.trim()) && isMultiDomain) {
                redirectionLink = `/ca${redirectionLink}`;
            }
            if (countryCode === 'ca' && !isValidCAPostalCode(zipcode.trim())) {
                console.warn('[FindUsComponentRedirect] CA domain with non-CA postal code - redirect prevented');
                return;
            }
            window.location.href = `${window.location.origin}${redirectionLink}?address=${encodedZipcode}`;
        } catch (error) {
            console.error('[FindUsComponentRedirect] Failed to construct redirect URL:', error);
        }
    }

    /**
     * Retrieves redirection link from brand data API.
     * @returns Promise resolving to redirect URL or undefined
     */
    private static async getRedirectionLinkFromBrandData(): Promise<string | undefined> {
        try {
            const brandData = await getBrandData();
            if (brandData) {
                const redirectLink = brandData.request_button_link_type;
                return redirectLink;
            }
        } catch (error) {
            console.error('[FindUsComponentRedirect] Failed to fetch brand data:', error);
        }
        return undefined;
    }
}